<div class="wrapper step-three">
    <div class="step-content">

        <div class="templates position-relative">
            <div class="arrows-left position-absolute">
                <img
                        (click)="scroll(target, 'left')"
                        src="./assets/imgs/Arrow-slider-left.svg"
                />
            </div>
            <div class="arrows-right position-absolute">
                <img (click)="scroll(target, 'right')" src="./assets/imgs/Arrow-slider-right.svg" />
            </div>
            <div #target class="grid">
                <div class="card" style="width: 200px;border-radius: 8px;height: 350px">
                    <img class="card-img-top" src="assets/imgs/brand4.png" width="202px"
                         height="150px">
                    <div class="card-body" style="padding-right: unset;
                padding-bottom: unset;line-height: unset!important;">
                        <h5 class="card-title" style="font-weight: 600;font-size: 14px;color:#1D2126">Card title</h5>
                        <p class="card-text" style="font-size: 12px;font-weight: 400">
                            Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                        <a href="#" class="card-link" style="font-weight: 600;text-decoration: underline;
                        font-size: 11px;color:#182F7C">Click Here</a>
                    </div>
                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: unset;">
                            <a href="#" class="card-link" style="font-weight:700;text-decoration: underline;
                        font-size: 13px;color:#182F7C">Explore More</a>
                    </div>
                </div>
                <div class="card" style="width: 200px;border-radius: 8px;height: 350px">
                    <img class="card-img-top" src="assets/imgs/brand4.png" width="202px"
                         height="150px">
                    <div class="card-body" style="padding-right: unset;
                padding-bottom: unset;line-height: unset!important;">
                        <h5 class="card-title" style="font-weight: 600;font-size: 14px;color:#1D2126">Card title</h5>
                        <p class="card-text" style="font-size: 12px;font-weight: 400">
                            Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                        <a href="#" class="card-link" style="font-weight: 600;text-decoration: underline;
                        font-size: 11px;color:#182F7C">Click Here</a>
                    </div>
                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: unset;">
                        <a href="#" class="card-link" style="font-weight:700;text-decoration: underline;
                        font-size: 13px;color:#182F7C">Explore More</a>
                    </div>
                </div>
                <div class="card" style="width: 200px;border-radius: 8px;height: 350px">
                    <img class="card-img-top" src="assets/imgs/brand4.png" width="202px"
                         height="150px">
                    <div class="card-body" style="padding-right: unset;
                padding-bottom: unset;line-height: unset!important;">
                        <h5 class="card-title" style="font-weight: 600;font-size: 14px;color:#1D2126">Card title</h5>
                        <p class="card-text" style="font-size: 12px;font-weight: 400">
                            Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                        <a href="#" class="card-link" style="font-weight: 600;text-decoration: underline;
                        font-size: 11px;color:#182F7C">Click Here</a>
                    </div>
                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: unset;">
                        <a href="#" class="card-link" style="font-weight:700;text-decoration: underline;
                        font-size: 13px;color:#182F7C">Explore More</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <button
          routerLink="/design-menu/step-three"
          class="next btn bg-gold text-white mt-5"
        >
          {{ "common.next" | translate }}
        </button> -->
    </div>
</div>
